export default (payload) => {
  const suppliers = {}
  for (const item in payload) {
    // Avoid NOT QUOTED
    if (!(payload[item].suppliers && payload[item].suppliers.length > 0)) {
      continue
    }

    payload[item].suppliers.map(s => {
      if (!s.supplier) { return }
      const noRespondQuotation = s.supplier.state && s.supplier.state.noQuote
      if (suppliers[s.supplier._id]) {
        const itemsQuotedFiltered = CheckQuotationsBySupplierId({
          supplierId: s.supplier._id,
          item: payload[item]
        })

        if (itemsQuotedFiltered) {
          suppliers[s.supplier._id].haveQuotation = itemsQuotedFiltered.haveQuotation
          suppliers[s.supplier._id].itemsQuoted.push(itemsQuotedFiltered.itemsQuoted)
          suppliers[s.supplier._id].price += itemsQuotedFiltered.price
          suppliers[s.supplier._id].itemsReceived += itemsQuotedFiltered.itemsReceived
          suppliers[s.supplier._id].receiveDate = itemsQuotedFiltered.receiveDate
          suppliers[s.supplier._id].requestDate = itemsQuotedFiltered.requestDate
          suppliers[s.supplier._id].noRespondQuotation = itemsQuotedFiltered.noRespondQuotation || noRespondQuotation
        }

        suppliers[s.supplier._id].total = suppliers[s.supplier._id].total + 1
      } else {
        const itemsQuotedFiltered = CheckQuotationsBySupplierId({
          supplierId: s.supplier._id,
          item: payload[item]
        })

        const supplierInfo = {
          name: s.supplier.name,
          total: 1,
          itemsQuoted: [],
          receiveDate: false,
          requestDate: false,
          isPriceGuaranted: false,
          price: 0,
          selected: false, // Check use
          itemsReceived: 0, // How many items receive result
          haveQuotation: false,
          noRespondQuotation
        }

        if (itemsQuotedFiltered) {
          supplierInfo.itemsQuoted.push(itemsQuotedFiltered.itemsQuoted)
          supplierInfo.receiveDate = itemsQuotedFiltered.receiveDate
          supplierInfo.requestDate = itemsQuotedFiltered.requestDate
          supplierInfo.isPriceGuaranted = itemsQuotedFiltered.isPriceGuaranted
          supplierInfo.price = itemsQuotedFiltered.price
          supplierInfo.itemsReceived = itemsQuotedFiltered.itemsReceived
          supplierInfo.haveQuotation = itemsQuotedFiltered.haveQuotation
        }

        suppliers[s.supplier._id] = supplierInfo

        if (s.supplier.contact && s.supplier.contact.comercialEmail) {
          suppliers[s.supplier._id].email = s.supplier.contact.comercialEmail
        }
      }
    })
  }
  return suppliers
}

const CheckQuotationsBySupplierId = ({ supplierId, item }) => {
  if (item.suppliersQuote && item.suppliersQuote.quotations) {
    const haveQuotation = item.suppliersQuote.quotations.find(i => i.supplier.toString() === supplierId)
    if (haveQuotation) {
      return {
        itemsQuoted: item._id,
        haveQuotation: true,
        requestDate: haveQuotation.requestDate || false,
        receiveDate: haveQuotation.receiveDate || false,
        isPriceGuaranted: haveQuotation.isPriceGuaranted || false,
        price: haveQuotation.price || 0,
        itemsReceived: haveQuotation.receiveDate ? 1 : 0,
        noRespondQuotation: haveQuotation.supplier &&
          haveQuotation.supplier.state &&
          haveQuotation.supplier.state.noQuote
      }
    } else {
      return false
    }
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/brain/quote/load-event-list/MapAllSuppliers.js